var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 21L19.25 24.5L26.25 17.5M5.25 21C5.25 23.0683 5.65739 25.1164 6.4489 27.0273C7.24041 28.9381 8.40055 30.6744 9.86307 32.1369C11.3256 33.5995 13.0619 34.7596 14.9727 35.5511C16.8836 36.3426 18.9317 36.75 21 36.75C23.0683 36.75 25.1164 36.3426 27.0273 35.5511C28.9381 34.7596 30.6744 33.5995 32.1369 32.1369C33.5995 30.6744 34.7596 28.9381 35.5511 27.0273C36.3426 25.1164 36.75 23.0683 36.75 21C36.75 18.9317 36.3426 16.8836 35.5511 14.9727C34.7596 13.0619 33.5995 11.3256 32.1369 9.86307C30.6744 8.40055 28.9381 7.24041 27.0273 6.4489C25.1164 5.65739 23.0683 5.25 21 5.25C18.9317 5.25 16.8836 5.65739 14.9727 6.4489C13.0619 7.24041 11.3256 8.40055 9.86307 9.86307C8.40055 11.3256 7.24041 13.0619 6.4489 14.9727C5.65739 16.8836 5.25 18.9317 5.25 21Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.1b31191f170d7558cc8f305265b74e1d.svg";
export { ForwardRef as ReactComponent };